// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Rankings-module__tableWrapper___atNX9"};